module.exports = __webpack_public_path__ + "img/paper.01ceafa7.png";